// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./themes/inspinia/css/bootstrap.css
// module id = 1303
// module chunks = 0